var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action } from 'mobx';
import { api } from 'helpers/Api';
import { Invoice, CashDesk, Ticket, TicketCashDesk, PacketTicket, CollaboratorTicket, } from './Model';
export default class ReportsStore {
    constructor() {
        this.invoices = [];
        this.tickets = [];
        this.collaboratorTickets = [];
        this.operatorTickets = [];
        this.packetTickets = [];
        this.cashDesks = [];
        this.invoicesLoaded = false;
        this.ticketsLoaded = false;
        this.collaboratorTicketsLoaded = false;
        this.operatorTicketsLoaded = false;
        this.ticketGratisLoaded = false;
        this.ticketCanceledLoaded = false;
        this.cashDesksLoaded = false;
        this.ticketCashDesksLoaded = false;
        this.packetTicketsLoaded = false;
        this.total = 0;
        this.ticketCashDesk = [];
        this.ticketGratis = [];
        this.selected = '';
        this.ticketCanceled = [];
        this.ticketCashDesksFromTo = [];
        this.ticketCashDesksFromToLoaded = false;
        this.eagerCollaboratorTicket = '[ticketRefunded]';
        this.eagerPacketTicket = '[lines, ticketRefunded.[lines, tickets], tickets.[lines, operationLine.[businessUnit]]]';
        this.readTicketsUser = (user) => {
            return api
                .get(`ticketsV2/user/${user}?eager=${Eagers.Ticket}`)
                .then(this.setUserTickets);
        };
        this.setTicketCashDesksFromTo = (ticketCashDesksFromTo) => {
            // console.log('Report Store - setTicketCashDesk - ticketCashDesks: ', ticketCashDesks)
            this.ticketCashDesksFromTo = ticketCashDesksFromTo.map((ticketCashDesk) => new TicketCashDesk(ticketCashDesk));
            this.ticketCashDesksFromToLoaded = true;
            return this.ticketCashDesksFromTo;
        };
        this.cancelTicket = (ticket, user) => {
            if (ticket instanceof CollaboratorTicket) {
                // tiene que ir antes de instanceof Ticket
                return api.post(`collaboratorTickets/refund`, {
                    ticketPayload: ticket,
                    userid: user.id,
                });
            }
            else if (ticket instanceof Ticket) {
                return api.post(`tickets/refund`, {
                    ticketPayload: ticket,
                    userid: user.id,
                });
            }
            else {
                return new Promise((resolve, reject) => {
                    reject({});
                });
            }
        };
        this.setTickets = (tickets) => {
            // console.log('Reports/Store - setTickets')
            this.tickets = tickets.map((ticket) => new Ticket(ticket));
            this.invoicesLoaded = true;
            return this.tickets;
        };
        this.setUserTickets = (tickets) => {
            var _a, _b;
            // console.log('Reports/Store - setTickets')
            const _tickets = ((_a = tickets.tickets) === null || _a === void 0 ? void 0 : _a.map((ticket) => new Ticket(ticket))) || [];
            const _collaboratorTickets = ((_b = tickets.collaboratorTickets) === null || _b === void 0 ? void 0 : _b.map((ticket) => new CollaboratorTicket(ticket))) || [];
            this.tickets = [..._tickets, ..._collaboratorTickets].sort((a, b) => b.datecheck.getTime() - a.datecheck.getTime());
            this.invoicesLoaded = true;
            return this.tickets;
        };
        this.setCollaboratorTickets = (tickets) => {
            this.collaboratorTickets = tickets
                .filter((ticket) => !ticket.refund_id)
                .map((ticket) => new CollaboratorTicket(ticket));
            this.collaboratorTicketsLoaded = true;
        };
        this.setOperatorTickets = (tickets) => {
            this.operatorTickets = tickets
                .filter((ticket) => !ticket.refund_id)
                .map((ticket) => new CollaboratorTicket(ticket));
            this.operatorTicketsLoaded = true;
        };
        this.setInvoices = (invoices) => {
            this.invoices = invoices.map((invoice) => new Invoice(invoice));
            this.invoicesLoaded = true;
        };
        this.setCashDesk = (cashDesks) => {
            this.cashDesks = cashDesks.map((cashDesk) => new CashDesk(cashDesk));
            this.cashDesksLoaded = true;
        };
        this.setTicketCashDesk = (ticketCashDesks) => {
            // console.log('Report Store - setTicketCashDesk - ticketCashDesks: ', ticketCashDesks)
            this.ticketCashDesk = ticketCashDesks.map((ticketCashDesk) => new TicketCashDesk(ticketCashDesk));
            this.ticketCashDesksLoaded = true;
        };
        this.setTicketGratis = (tickets) => {
            this.ticketGratis = tickets.map((ticket) => new Ticket(ticket));
            this.ticketGratisLoaded = true;
        };
        this.setPacketTickets = (packetTickets) => {
            // console.log('Reports/Store - setPacketTickets - packetTickets.length: ', packetTickets.length)
            this.packetTickets = packetTickets
                .filter((item) => !item.refund_id)
                .map((packetTicket) => new PacketTicket(packetTicket));
            this.packetTicketsLoaded = true;
            return this.packetTickets;
        };
    }
    readInvoices() {
        return api.get('invoice').then(this.setInvoices);
    }
    readTickets() {
        return api.get(`tickets?eager=${Eagers.Ticket}`).then(this.setTickets);
    }
    // los vendidos como colaborador
    readCollaboratorTickets() {
        return api
            .get(`collaboratorTickets/collaborator?eager=${this.eagerCollaboratorTicket}`)
            .then(this.setCollaboratorTickets);
    }
    // los vendidos por colaboradores
    readOperatorTickets() {
        return api
            .get(`collaboratorTickets/operator?eager=${this.eagerCollaboratorTicket}`)
            .then(this.setOperatorTickets);
    }
    readPacketickets() {
        return api
            .get(`packetTickets?eager=${this.eagerPacketTicket}`)
            .then(this.setPacketTickets);
    }
    readCashDesk() {
        return api.get('cashDesk').then(this.setCashDesk);
    }
    readTicketCashDesks() {
        return api
            .get('ticketCashDesks?eager=[articleLines, stretchLines]')
            .then(this.setTicketCashDesk);
    }
    readTicketCashDesksFromTo(from, to) {
        return api
            .post('ticketCashDesksFromTo?eager=[articleLines, stretchLines]', {
            from,
            to,
        })
            .then(this.setTicketCashDesksFromTo);
    }
    readTicketGratis() {
        return api
            .get(`ticketGratis?eager=${Eagers.Ticket}`)
            .then(this.setTicketGratis);
    }
    readTicketCanceled() {
        return api
            .get('ticketCanceled?eager=[operationLine, operationLine.businessUnit, user, stretch, lines]')
            .then(this.setTicketGratis);
    }
    readTicket(id) {
        return api.get(`tickets?id=${id}&eager=${Eagers.Ticket}`);
    }
    readTicketCorrected(id) {
        return api
            .get(`/rtickets/${id}?eager=[lines, user, operationLine.[businessUnit], payments]`)
            .then((result) => {
            // console.log('result: ', result)
            return result;
        });
    }
    refund(ticket, user) {
        // return api.post(`tickets/refund/${ticket.numero}/${user.id}`, {ticket, user})
        return api.post(`tickets/refund`, { ticketPayload: ticket, userid: user.id });
    }
    validaNumero(numero, stretch) {
        return api.get(`tickets/valida/${numero}/${stretch}`);
    }
    pdfPost(rendered) {
        return api.post(`tickets/pdf`, { rendered }, { responseType: 'blob' });
    }
    pdf(numero) {
        return api.get(`ticket/pdf/${numero}`, { responseType: 'arraybuffer' });
    }
    setSelected(value) {
        this.selected = value;
    }
    setTotal(total) {
        // console.log('Store - total', total)
        this.total = total;
    }
}
__decorate([
    observable
], ReportsStore.prototype, "invoices", void 0);
__decorate([
    observable
], ReportsStore.prototype, "tickets", void 0);
__decorate([
    observable
], ReportsStore.prototype, "collaboratorTickets", void 0);
__decorate([
    observable
], ReportsStore.prototype, "operatorTickets", void 0);
__decorate([
    observable
], ReportsStore.prototype, "packetTickets", void 0);
__decorate([
    observable
], ReportsStore.prototype, "cashDesks", void 0);
__decorate([
    observable
], ReportsStore.prototype, "invoicesLoaded", void 0);
__decorate([
    observable
], ReportsStore.prototype, "ticketsLoaded", void 0);
__decorate([
    observable
], ReportsStore.prototype, "collaboratorTicketsLoaded", void 0);
__decorate([
    observable
], ReportsStore.prototype, "operatorTicketsLoaded", void 0);
__decorate([
    observable
], ReportsStore.prototype, "ticketGratisLoaded", void 0);
__decorate([
    observable
], ReportsStore.prototype, "ticketCanceledLoaded", void 0);
__decorate([
    observable
], ReportsStore.prototype, "cashDesksLoaded", void 0);
__decorate([
    observable
], ReportsStore.prototype, "ticketCashDesksLoaded", void 0);
__decorate([
    observable
], ReportsStore.prototype, "packetTicketsLoaded", void 0);
__decorate([
    observable
], ReportsStore.prototype, "total", void 0);
__decorate([
    observable
], ReportsStore.prototype, "ticketCashDesk", void 0);
__decorate([
    observable
], ReportsStore.prototype, "ticketGratis", void 0);
__decorate([
    observable
], ReportsStore.prototype, "selected", void 0);
__decorate([
    observable
], ReportsStore.prototype, "ticketCanceled", void 0);
__decorate([
    observable
], ReportsStore.prototype, "ticketCashDesksFromTo", void 0);
__decorate([
    observable
], ReportsStore.prototype, "ticketCashDesksFromToLoaded", void 0);
__decorate([
    action
], ReportsStore.prototype, "setTicketCashDesksFromTo", void 0);
__decorate([
    action
], ReportsStore.prototype, "setSelected", null);
__decorate([
    action
], ReportsStore.prototype, "setTotal", null);
__decorate([
    action
], ReportsStore.prototype, "setTickets", void 0);
__decorate([
    action
], ReportsStore.prototype, "setUserTickets", void 0);
__decorate([
    action
], ReportsStore.prototype, "setCollaboratorTickets", void 0);
__decorate([
    action
], ReportsStore.prototype, "setOperatorTickets", void 0);
__decorate([
    action
], ReportsStore.prototype, "setInvoices", void 0);
__decorate([
    action
], ReportsStore.prototype, "setCashDesk", void 0);
__decorate([
    action
], ReportsStore.prototype, "setTicketCashDesk", void 0);
__decorate([
    action
], ReportsStore.prototype, "setTicketGratis", void 0);
__decorate([
    action
], ReportsStore.prototype, "setPacketTickets", void 0);
export const typeList = {
    Report: 'report',
    Calendar: 'calendar',
};
export const Eagers = {
    Ticket: '[stretch, ticketRefunded.[lines, user, operationLine.[businessUnit], payments],lines, user, operationLine.[businessUnit], payments]',
    CollaboratorTicket: '[ticketRefunded]',
    PacketTicket: '[operationLine.[businessUnit], lines, tickets.[lines, operationLine.[businessUnit]]]',
    CollaboratorPacketTicket: '[ticketRefunded.[tickets], tickets]',
    Voucher: '[lines]',
    VoucherLine: '[voucher.[lines]]',
    CartToken: '',
    CartTicket: '',
    OperationLines: '[stretches.[primaryMoney, operationLine.[businessUnit], receiptLayout, headboard, stretchOtas, tax, prices.[passengerCategory], ' +
        'vueltaPrices.[passengerCategory]], businessUnit, ' +
        'packets.[primaryMoney, headboard, stretches.[operationLine.[businessUnit]], tax, operationLine.[businessUnit], prices.[passengerCategory]]]',
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/Store.ts
// module id = 344
// module chunks = 0